// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__3hdKt","checkbox_purple":"Checkbox_checkbox_purple__2mY2I","link":"Checkbox_link__2y86U","link_purple":"Checkbox_link_purple__Bg8W1"};